import StickySidebar from "sticky-sidebar-v2";

let CommentViewDataModel = window.CommentViewData;
let bookmarkStatus = true;
let sidebar = null;

const checkTopicIsBookmarkThenFunction = () => {
  document.querySelectorAll(".js-bookmark-btn").forEach(function (item) {
    item.classList.add("is-bookmarked");
  });

  bookmarkStatus = false;
}

// document is ready when run code
document.addEventListener("DOMContentLoaded", function () {
  initStickySidebar();

  // init light gallery
  var lightGalleryItems = Array.from(
    document.querySelectorAll(".lightgallery")
  );

  if (lightGalleryItems.length) {
    lightGalleryItems.forEach(function (item) {
      window.lightGallery(item, {
        thumbnail: true,
      });
    });
  }

  //init four columns slider
  window.initSlider({
    selector: ".js-four-columns-slider",
    slidesPerView: "auto",
    spaceBetweenInMobile: 16,
    spaceBetweenInDesktop: 24,
  });

  window.checkItemIsFavorite(Number(CommentViewDataModel.topicId), 32, checkTopicIsBookmarkThenFunction);
});

// re init or destroy sidebar in change between mobile and desktop
window.addEventListener('resize', () => {
  if (sidebar && window.innerWidth < 993) {
    sidebar.destroy();
    sidebar.updateSticky();
    sidebar = null;
  } else {
    initStickySidebar();
  }
});

// bookmark topic item
window.topicBookmark = function (element, type, id) {
  window.itemBookmark(element, type, id, bookmarkStatus);

  window.checkItemIsFavorite(Number(CommentViewDataModel.topicId), 32, checkTopicIsBookmarkThenFunction);
};

// sticky sidebar
const initStickySidebar = () => {
  if (document.body.clientWidth >= 993) {
    if (!sidebar) {
      sidebar = new StickySidebar(".js-sidebar", {
        topSpacing: 20,
        bottomSpacing: 20,
        containerSelector: ".js-sidebar-content",
        resizeSensor: true,
        innerWrapperSelector: ".js-sidebar-inner",
      });
    }
  } else {
    if (sidebar) {
      sidebar.destroy();
      sidebar.updateSticky();
    }
  }
};
